import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

export const User = PropTypes.shape({
  smallAvatar: PropTypes.string.isRequired,
  standardAvatarPath: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  standardAvatar: PropTypes.string.isRequired,
  profileName: PropTypes.string.isRequired,
  'avatar@3x': PropTypes.string.isRequired,
  fullName: PropTypes.string.isRequired,
  externalIds: PropTypes.objectOf(PropTypes.string),
});

export const ImmutableUser = ImmutablePropTypes.mapContains({
  smallAvatar: PropTypes.string.isRequired,
  standardAvatarPath: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  standardAvatar: PropTypes.string.isRequired,
  profileName: PropTypes.string.isRequired,
  'avatar@3x': PropTypes.string.isRequired,
  fullName: PropTypes.string.isRequired,
  externalIds: ImmutablePropTypes.mapOf(PropTypes.string, PropTypes.string),
});
